<template>
  <v-card width="100%">
    <div class="barometer-wrapper">
      <div class="barometer-header">
        <h2>Kleuringen</h2>
        <h3 v-if="selectedDataView == 'months'">
          <span v-for="(month, index) in months" :key="index">
            <span v-if="month.id == selectedDataMonths"> {{ month.name }}</span>
          </span>
        </h3>
        <h3
          v-if="selectedDataView == 'fourweeks'"
        >week {{(selectedDataFourWeeks * 4) - 3 }} t/m {{(selectedDataFourWeeks * 4)}}</h3>
        <h3 v-if="selectedDataView == 'weeks'">week {{ selectedDataWeek }}</h3>
      </div>
      <div class="barometer-canvas-wrapper">
        <canvas :id="canvasID" generateGradient="false" width="210" height="140" ></canvas>
      </div>

      <div v-if="rate != null" class="barometer-footer">
        <p v-if="rate == 1" class="barometer-rate ma-0"><span v-if="target && rate > target" class="on-fire"></span>{{rate}} kleuringen</p>
        <p v-else class="barometer-rate ma-0"><span v-if="target && rate > target" class="on-fire"></span>{{rate}} kleuringen</p>
        <p v-if="target" class="barometer-description ma-0" v-html="rateinfo"></p>
      </div>

      <div v-if="!target" class="barometer-footer">
        <p class="barometer-rate ma-0"> &nbsp;</p>
        <div  class="barometer-alert">
          <v-alert 
            :value="true"
            type="warning"
          >
            Er is nog geen doel ingesteld.
          </v-alert>
         </div>
      </div>

    </div>
  </v-card>
</template>

<script>
import { bus } from "../../main";
export default {
  props: ["level", "marks", "aperture", "colorStop", "colorStart", "canvasID", "rate", "weeknr", "target",
    "selectedDataView",
    "selectedDataWeek",
    "selectedDataMonths",
    "selectedDataFourWeeks",
    "months"],
  name: "gaugeColour",
  data: () => ({
    mini: true,
    id: null, //passed getal door
    canvasRender: null,

    opts: {
      angle: -0.1, /// The span of the gauge arc
      lineWidth: 0.26, // The line thickness
      pointer: {
        length: 0.7, // Relative to gauge radius
        strokeWidth: 0.035, // The thickness
        color: "#767676"
      },
      colorStart: "#333",
      colorStop: "#333",
      strokeColor: "rgb(204,204,204)",
      limitMax: true, // If false, max value increases automatically if value > maxValue
      // generateGradient: true,
      highDpiSupport: true,

      // percentColors: [[0.0, "#a9d70b"], [0.5, "#f9c802"], [1.0, "#ff0000"]],
      // staticZones: [
      //   { strokeStyle: "rgb(204,204,204)", min: 0, max: 120, height: 1.0 },
      //   { strokeStyle: "rgb(255,255,255)", min: 99, max: 100, height: 1.2 }
      // ],
      staticLabels: {
        font: "14px sans-serif", // Specifies font
        labels: [100], // Print labels at these values
        color: "#000000", // Optional: Label text color
        fractionDigits: 0 // Optional: Numerical precision. 0=round off.
      }
      // pointer: {
      //   // Extra optional pointer options:
      //   iconPath: "myicon.png", // Icon image source
      //   iconScale: 1, // Size scaling factor
      //   iconAngle: 90.0 // Rotation offset angle, degrees
      // }
    }
  }),

  created() {
    bus.$on("salonBarometerUpdate", this.updateData);
    if(this.colorStop && this.colorStart){
      this.opts.colorStop = this.colorStop;
      this.opts.colorStart = this.colorStart;
    } 
  },

  mounted() {
    this.updateData();    
  },

  methods: {
    updateData() {
      // var opts = this.opts;
      var target = document.getElementById(this.canvasID); // Passeren langs DOM element
      var gauge = new Gauge(target).setOptions(this.opts); // Unieke Gauge opbouwn
      
      gauge.setMinValue(0); // min value
      if(this.target){
        gauge.maxValue = this.target; // max gauge value
        gauge.set(this.rate); // actual value
      }
      else{
        gauge.maxValue = 100; // max gauge value
        gauge.set(0); // actual value
      }

    }
  },

  computed: {
    userRole() {
      return this.$store.state.userRole;
    },
    rateinfo() {
      if (this.rate >= this.target) {
        return `<span style="color: green;">Gefeliciteerd! De kleur doelstelling voor deze week is gehaald! Tijd voor een feestje!</span>`;
      } else {
        return `<span style="">Het doel is <b>${(this.target).toFixed(0)}</b> kleuren. <br>Nog <strong> ${(this.target -
          this.rate).toFixed(0)} </strong> kleuringen te gaan</span>`;
      }
    }
  }
};
</script>
